export default __webpack_public_path__ + "static/media/alert-inner.ca5fc8d1.svg";